var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongoDb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6095 126.923C102.423 126.923 124.971 103.677 124.971 75.0002C124.971 46.3239 102.423 23.0771 74.6095 23.0771C46.7956 23.0771 24.248 46.3239 24.248 75.0002C24.248 103.677 46.7956 126.923 74.6095 126.923Z",
    fill: "#13AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0716 68.6559C84.8906 54.1813 77.3728 49.4221 76.5632 47.6037C75.678 46.3209 74.7809 44.0391 74.7809 44.0391C74.7662 44.0006 74.7426 43.9326 74.715 43.8667C74.6235 45.1496 74.5763 45.6445 73.3999 46.9385C71.5782 48.4069 62.2319 56.4925 61.4715 72.9375C60.7623 88.2751 72.2176 97.4144 73.7668 98.5796L73.9429 98.7084V98.6973C73.9527 98.7743 74.4347 102.348 74.773 106.135H75.9868C76.2716 103.458 76.6985 100.799 77.2655 98.1709L77.3639 98.105C78.0569 97.5927 78.7176 97.0355 79.342 96.4368L79.4128 96.3709C82.706 93.2342 88.6264 85.9791 88.5684 74.4121C88.5561 72.4826 88.39 70.5573 88.0716 68.6559ZM74.6442 89.92C74.6442 89.92 74.6442 68.4085 75.3327 68.4125C75.8698 68.4125 76.5652 96.1599 76.5652 96.1599C75.6091 96.0413 74.6442 91.5933 74.6442 89.92Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.723,
    height: 103.846,
    fill: "white",
    transform: "translate(24.248 23.0771)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/MongoDB.3a154bc87757bc9ec59ded1305bf8257.svg";
export { ForwardRef as ReactComponent };